import { getCurrentUserToken } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "reactfire";
import { getPaymentDetail } from "../../handlers/getPaymentDetail";

export const PAYMENT_DETAIL_QUERY_KEY = "payment-detail";

export function usePaymentDetailQuery() {
  const auth = useAuth();

  return useQuery({
    queryKey: [PAYMENT_DETAIL_QUERY_KEY, auth.currentUser?.uid],
    queryFn: async () => {
      const token = await getCurrentUserToken();

      if (!token) throw new Error("No auth token");

      const response = await getPaymentDetail({ token });
      return response.data;
    },
    enabled: !!auth.currentUser?.uid,
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
